import gsap from 'gsap'

import Swiper from "swiper"
import { Navigation, Autoplay, FreeMode, EffectFade, Pagination, EffectCards } from "swiper/modules"

import "swiper/css"
import "swiper/css/navigation"
import "swiper/css/free-mode"
import "swiper/css/effect-fade"
import "swiper/css/effect-cards"

export const swiper = () => {
	trustpilot()
	articlesPreview()
	questions()
	successStories()
}

const trustpilot = () => {

	let els = document.querySelectorAll('[data-swiper="trustpilot"]')

	if (!els.length) return false

	els.forEach(el => {
		new Swiper(el, {
			modules: [EffectCards, Navigation, Autoplay],
			effect: 'cards',
			grabCursor: true,
			navigation: {
				prevEl: el.parentElement.querySelector('[data-button="previous"]'),
				nextEl: el.parentElement.querySelector('[data-button="next"]'),
			},
		})
	})
}

const articlesPreview = () => {

	let els = document.querySelectorAll('[data-swiper="articles-preview"]')

	if (!els.length) return false

	els.forEach(el => {
		new Swiper(el, {
			modules: [Navigation],
			slidesPerView: 'auto',
			grabCursor: true,
			centeredSlides: false,
			slidesPerView: 1.25,
			spaceBetween: 10,
			navigation: {
				prevEl: el.querySelector('[data-button="previous"]'),
				nextEl: el.querySelector('[data-button="next"]'),
			},
			breakpoints: {
				782: {
					slidesPerView: 2.5,
				},
				1280: {
					slidesPerView: 4,
				}
			}
		})
	})
}

const questions = () => {

	let el = document.querySelector('[data-swiper="questions"]')

	if (!el) return false

	new Swiper(el, {
		modules: [Autoplay],
		loop: true,
		slidesPerView: 'auto',
		centeredSlides: true,
		slideToClickedSlide: true,
		speed: 600,
		direction: "vertical",
		autoplay: {
			delay: 400,
			disableOnInteraction: false,
		}
	});
}

const successStories = () => {

	let els = document.querySelectorAll('[data-swiper="success-stories"]')

	if (!els.length) return false

	els.forEach(el => {
		let section = el.closest('.success-stories')

		new Swiper(el, {
			modules: [Navigation, EffectFade],
			effect: 'fade',
			fadeEffect: {
				crossFade: true,
			},
			autoHeight: true,
			speed: 600,
			grabCursor: true,
			navigation: {
				prevEl: section.querySelector('[data-button="previous"]'),
				nextEl: section.querySelector('[data-button="next"]'),
			},
		})
	})
}

export default () => { }



